module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/landing-hero-8c50a6e04fcbfcbac71aa54a79a58baf.png";